module.exports = __webpack_public_path__ + "img/PL08707.6621b428.png";